import addAddress from "../../components/add-address-form/index.vue";
import myAddresses from "./components/my-addresses/index.vue";
import agentClients from "./components/agent-clients/index.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "addresses",
    data() {
        return {
            myAddresses: false,
            addAddress: true,
        };
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
    },
    components: {
        addAddress,
        myAddresses,
        agentClients,
    },
    created() {
        // this.fetchUserData();
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
        }),
        changeTab(current) {
            this.myAddresses = this.addAddress = false;
            if (current === "myAddresses") {
                this.myAddresses = true;
            } else if (current === "addAddress") {
                this.addAddress = true;
            }
        },
    },
};
